module.exports = __webpack_public_path__ + "static/3import-1e6e6d33695583f49cea8a2df117819f.png";